// extracted by mini-css-extract-plugin
export default {"summaryTiles":"SummaryTiles__summaryTiles-_GIu"};